import React from "react";
import { useParams } from 'react-router-dom';
//import CheckList from "./sublist/checklist";
import GlobalCheckList from "../../pages/common/globalchecklist"
import Student12TopMenu from "../studentInfo/student12topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentCheckList() {

  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
    <Student12TopMenu slug={slug} activeMenu={"CheckList"} />
    <div className="tak-instruct-group">
      <div className="row">
        <div className="col-md-12">    
        <PageNotes
              type={"Instructor"}
              pageName={"CheckList"}
              studentId={slug}
              instructorId={profile.id}
            />    
          <GlobalCheckList slug={slug} isStudent={false}/>
        </div>
      </div>
    </div>
    </>
  );
}
